import { render, staticRenderFns } from "./ContentCarousel.vue?vue&type=template&id=0ccf4b56&scoped=true&"
import script from "./ContentCarousel.vue?vue&type=script&lang=js&"
export * from "./ContentCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ContentCarousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ContentCarousel.vue?vue&type=style&index=1&id=0ccf4b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf4b56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\occasion-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccf4b56')) {
      api.createRecord('0ccf4b56', component.options)
    } else {
      api.reload('0ccf4b56', component.options)
    }
    module.hot.accept("./ContentCarousel.vue?vue&type=template&id=0ccf4b56&scoped=true&", function () {
      api.rerender('0ccf4b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "OccasionShop/components/Snippets/ContentCarousel.vue"
export default component.exports